import { render } from "./tubeForm.vue?vue&type=template&id=71d2ea54"
import script from "./tubeForm.vue?vue&type=script&lang=js"
export * from "./tubeForm.vue?vue&type=script&lang=js"

import "./tubeForm.vue?vue&type=style&index=0&id=71d2ea54&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__